// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay-loader {
  position: absolute;
  top: -24px;
  left: -24px;
  height: calc(100% + 24px);
  width: calc(100% + 24px);
  background-color: gray;
  opacity: 0.3;
  z-index: 9998;
}

.loader-icon {
  content: var(--loader);
  position: absolute;
  top: 40%;
  left: 45%;
  opacity: 1;
  z-index: 9999;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/loaders/overlay-loader/overlay-loader.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,wBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;AACF;;AAEA;EACE,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;AACF","sourcesContent":[".overlay-loader {\n  position: absolute;\n  top: -24px;\n  left: -24px;\n  height: calc(100% + 24px);\n  width: calc(100% + 24px);\n  background-color: gray;\n  opacity: .3;\n  z-index: 9998;\n}\n\n.loader-icon {\n  content: var(--loader);\n  position: absolute;\n  top: 40%;\n  left: 45%;\n  opacity: 1;\n  z-index: 9999;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
